// extracted by mini-css-extract-plugin
export default {"document":"DocumentsFormsList_document__+HO7e"};